// Auth
export const LOGIN = `${process.env.VUE_APP_API_URL}/api/v1/users/login`
export const VERIFY = `${process.env.VUE_APP_API_URL}/api/v1/users/verify`

// Order
export const ORDER_UPDATE = `${process.env.VUE_APP_API_URL}/api/v1/orders/update/`
export const ORDER_GET = `${process.env.VUE_APP_API_URL}/api/v1/orders/getAll`

// Transaction
export const TRANSACTION_GET = `${process.env.VUE_APP_API_URL}/api/v1/transactions/getAll`

// Collab
export const COLLAB_GET = `${process.env.VUE_APP_API_URL}/api/v1/collabs/getAll`
export const COLLAB_UPDATE = `${process.env.VUE_APP_API_URL}/api/v1/collabs/update`
export const COLLAB_DELETE = `${process.env.VUE_APP_API_URL}/api/v1/collabs/delete`

// Category
export const CATEGORY_CREATE = `${process.env.VUE_APP_API_URL}/api/v1/categories/create`
export const CATEGORY_UPDATE = `${process.env.VUE_APP_API_URL}/api/v1/categories/update/`
export const CATEGORY_DELETE = `${process.env.VUE_APP_API_URL}/api/v1/categories/delete/`
export const CATEGORY_GET = `${process.env.VUE_APP_API_URL}/api/v1/categories/getAll`

// Color
export const COLOR_CREATE = `${process.env.VUE_APP_API_URL}/api/v1/colors/create`
export const COLOR_UPDATE = `${process.env.VUE_APP_API_URL}/api/v1/colors/update/`
export const COLOR_DELETE = `${process.env.VUE_APP_API_URL}/api/v1/colors/delete/`
export const COLOR_GET = `${process.env.VUE_APP_API_URL}/api/v1/colors/getAll`

// Occasion
export const OCCASION_CREATE = `${process.env.VUE_APP_API_URL}/api/v1/occasions/create`
export const OCCASION_UPDATE = `${process.env.VUE_APP_API_URL}/api/v1/occasions/update/`
export const OCCASION_DELETE = `${process.env.VUE_APP_API_URL}/api/v1/occasions/delete/`
export const OCCASION_GET = `${process.env.VUE_APP_API_URL}/api/v1/occasions/getAll`

// City
export const CITY_CREATE = `${process.env.VUE_APP_API_URL}/api/v1/cities/create`
export const CITY_UPDATE = `${process.env.VUE_APP_API_URL}/api/v1/cities/update/`
export const CITY_DELETE = `${process.env.VUE_APP_API_URL}/api/v1/cities/delete/`
export const CITY_GET = `${process.env.VUE_APP_API_URL}/api/v1/cities/getAll`

// Config
export const CONFIG_GET = `${process.env.VUE_APP_API_URL}/api/v1/configs/getByType`
export const CONFIG_UPDATE = `${process.env.VUE_APP_API_URL}/api/v1/configs/updateByType`

// Banner
export const BANNER_DELETE = `${process.env.VUE_APP_API_URL}/api/v1/configs/deleteBanner`

// Showcase
export const SHOWCASE_CREATE = `${process.env.VUE_APP_API_URL}/api/v1/configs/addShowcase`
export const SHOWCASE_DELETE = `${process.env.VUE_APP_API_URL}/api/v1/configs/deleteShowcase`

// Product
export const PRODUCT_CREATE = `${process.env.VUE_APP_API_URL}/api/v1/products/create`
export const PRODUCT_GET = `${process.env.VUE_APP_API_URL}/api/v1/products/getAll`
export const PRODUCT_UPDATE = `${process.env.VUE_APP_API_URL}/api/v1/products/update`
export const PRODUCT_DELETE = `${process.env.VUE_APP_API_URL}/api/v1/products/delete`
export const PRODUCT_GET_BY_NAME = `${process.env.VUE_APP_API_URL}/api/v1/products/getByName`
export const PRODUCT_GET_ONE = `${process.env.VUE_APP_API_URL}/api/v1/products/getOne`
